import { render, staticRenderFns } from "./a2p-brand-review-dialog.vue?vue&type=template&id=5d9d0b5e"
import script from "./a2p-brand-review-dialog.vue?vue&type=script&lang=js"
export * from "./a2p-brand-review-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports